import React from "react";
import { SmlLogo } from "../components/Logo";
import { DATA, Product } from "../constants/data";
import { ProductPage } from "../templates/Product";

const Home = () => {
  return (
    <>
      <SmlLogo />
      <div className="max-w-screen-lg mx-auto select-none pt-16 sm:pt-5 px-5 sm:px-0 flex sm:justify-end">
        <a
          href="/bt60"
          className="sm:text-sm text-xs bg-gray-50 transition-colors hover:bg-gray-100  text-gray-400 hover:text-gray-900 px-2 py-1 sm:px-3 sm:py-1 rounded-md"
        >
          Looking for BT60v1? Click Here!
        </a>
      </div>
      <ProductPage data={DATA[Product.BTCKP]} />
    </>
  );
};
export default Home;
